import { useState, useEffect } from "react";
import { ScannedData } from "../types/foodManagement";
import { FoodItem } from "../services/foodApiService";
import { FoodManagementContext } from "./createFoodManagementContext";

export const FoodManagementProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [scannedData, setScannedData] = useState<ScannedData | null>(null);
  const [foodItemsFromBackend, setFoodItemsFromBackend] = useState<FoodItem[]>(
    []
  );
  const [uploadedImage, setUploadedImage] = useState<string | null>(null);

  // Initialize documentId from localStorage
  const [documentId, setDocumentId] = useState<string | null>(() => {
    const saved = localStorage.getItem("glucera_document_id");
    return saved;
  });

  // Debug documentId state changes and persist to localStorage
  const handleSetDocumentId = (newDocumentId: string | null) => {
    setDocumentId(newDocumentId);

    // Save to localStorage
    if (newDocumentId) {
      localStorage.setItem("glucera_document_id", newDocumentId);
    } else {
      localStorage.removeItem("glucera_document_id");
    }
  };

  return (
    <FoodManagementContext.Provider
      value={{
        scannedData,
        setScannedData,
        foodItemsFromBackend,
        setFoodItemsFromBackend,
        uploadedImage,
        setUploadedImage,
        documentId,
        setDocumentId: handleSetDocumentId,
      }}
    >
      {children}
    </FoodManagementContext.Provider>
  );
};
